<div class="title-divider-print-buttons mt-md-2">
  <h1>{{"unsupported.title" | translate}}</h1>
</div>

<p class="lead">
  <span>{{"unsupported.text" | translate}}</span><br />
  <span>{{"security.adminHint" | translate}}</span>
</p>

<span>{{"security.actionUrl" | translate}}</span>
<ul>
  <li>{{ securityData.actionUrl }}</li>
</ul>

<span>{{"security.erweiterung" | translate}}</span>
<ul>
  <li>{{ securityData.erweiterung }}</li>
</ul>

<span>{{"security.kanton" | translate}}</span>
<ul>
  <li>{{ securityData.kanton }}</li>
</ul>
